jQuery(document).on("change", '[role="checkbox"] input[type="checkbox"]', handleCheckboxClicked);

function handleCheckboxClicked() {
  setAriaCheckedValue(this);
}

function setAriaCheckedValue(input) {
  jQuery(input).closest('[role="checkbox"]').attr("aria-checked", jQuery(input).is(":checked"));
}

// Initialize
if (jQuery('[role="checkbox"] input[type="checkbox"]').length) {
  // Sync changes from set value
  setInterval(function () {
    jQuery('[role="checkbox"] input[type="checkbox"]').each(function () {
      setAriaCheckedValue(this);
    });
  }, 10000);
}
